import React from 'react';

const About = () => {
    return <h2>Abou Page</h2>;
}
export default About;